/**
 * Money formatting — the codebase stores money as integer CENTS everywhere (never floats). This
 * is the single cents→USD renderer the SPA uses so a balance/rent/fee always displays identically.
 */

/** Format integer cents as a USD currency string, e.g. 250000 → "$2,500.00". Negatives → "-$…". */
export function formatCents(cents: number): string {
  if (!Number.isFinite(cents)) return '$0.00';
  const negative = cents < 0;
  const abs = Math.abs(Math.round(cents));
  const dollars = Math.floor(abs / 100);
  const remainder = abs % 100;
  const formatted = `$${dollars.toLocaleString('en-US')}.${remainder.toString().padStart(2, '0')}`;
  return negative ? `-${formatted}` : formatted;
}

/**
 * Render a tenant BALANCE in cents with a plain-language sign. A positive balance is what the
 * tenant OWES; a negative balance is a CREDIT on their account; zero is paid in full. Returns the
 * amount string + a human label so the UI never relies on color alone to convey owed vs. credit.
 */
export function describeBalance(cents: number): { amount: string; label: string } {
  if (cents > 0) return { amount: formatCents(cents), label: 'balance due' };
  if (cents < 0) return { amount: formatCents(Math.abs(cents)), label: 'credit balance' };
  return { amount: formatCents(0), label: 'paid in full' };
}
